import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { OrderManagementContainerService } from 'src/app/service/OrderManagement/order-management-container.service';
import { APIFactoryEndPoints } from '../../apifactory-end-points';
import { SaveAsExcelfileService } from '../../CommonService/save-as-excelfile.service';
import { Constant } from '../../constant';
import { LocalStorageService } from '../../LocalStorageService';
import moment from 'moment';
import { ErrorLog } from 'src/app/model/Common/error-log';
import { MainContainerService } from 'src/app/service/main-container.service';

@Component({
  selector: 'app-select-preference',
  templateUrl: './select-preference.component.html',
  styleUrls: ['./select-preference.component.css']
})
export class SelectPreferenceComponent implements OnInit, OnDestroy {

  exportDataSubScription: Subscription;
  // saveAsExcelFile: SaveAsExcelfileService = new SaveAsExcelfileService();
  selectedChoice: string = "";

  errorLog: ErrorLog = new ErrorLog();

  private insertErrorLogSubscription: Subscription;

  constructor(
    private apiFactory: APIFactoryEndPoints,
    private http: HttpClient,
    private constant: Constant,
    public persistenceService: LocalStorageService,
    public saveAsExcelFile: SaveAsExcelfileService,
    public dialogRef: MatDialogRef<SelectPreferenceComponent>,
    private containerService: OrderManagementContainerService,
    private mainContainerService: MainContainerService,
    @Inject(MAT_DIALOG_DATA) public previewValue3: any
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  onClick(value: string) {
    this.selectedChoice = value;
    console.log(this.selectedChoice)
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  cancel() {
    this.dialogRef.close();
  }

  export() {
    if(this.selectedChoice == ""){
      return;
    }
    //set export Type as Summary or Details based on a dialog
    // this.exportDataSubScription = this.http.post("http://localhost:8090/mobitrixserverold/exportCsvByType/Summary/Process%20Order", this.previewValue3.requestView)
    this.exportDataSubScription = this.containerService.exportOrderStock(this.apiFactory.exportDatatoCSV, this.selectedChoice, this.previewValue3.subModuleName, this.previewValue3.requestView).subscribe((data) => {
      this.saveAsExcelFile.saveAsExcelFile(data, this.previewValue3.excelFileName)
      this.dialogRef.close();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("export", error);
      });
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = this.previewValue3.subModuleName + " Export";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = this.persistenceService.get('OS');
    if (error?.error?.message|| error?.error?.message!= '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    this.insertErrorLogSubscription = this.mainContainerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    });
  }

}
